  import React, { useState } from "react";
  import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Select,
    MenuItem,
    IconButton,
    Box,
    Tooltip,
    TablePagination,
    Dialog,
    DialogTitle,
    DialogContent,
    Typography,
    Skeleton,
  } from "@mui/material";
  import VisibilityIcon from "@mui/icons-material/Visibility";
  import EditIcon from "@mui/icons-material/Edit";
  import DeleteIcon from "@mui/icons-material/Delete";
  import HistoryIcon from "@mui/icons-material/History";
  import { isAdmin, isAdminOrIsUser } from "../../utility/isAdmin";
  import PersonIcon from "@mui/icons-material/Person";
  // MUI Timeline components
  import Timeline from "@mui/lab/Timeline";
  import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
  import TimelineItem from "@mui/lab/TimelineItem";
  import TimelineSeparator from "@mui/lab/TimelineSeparator";
  import TimelineConnector from "@mui/lab/TimelineConnector";
  import TimelineContent from "@mui/lab/TimelineContent";
  import TimelineDot from "@mui/lab/TimelineDot";
  import FolderOpenIcon from "@mui/icons-material/FolderOpen";
  import BuildCircleIcon from "@mui/icons-material/BuildCircle";
  import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
  import CheckCircleIcon from "@mui/icons-material/CheckCircle";
  import LockIcon from "@mui/icons-material/Lock";
  import { useDispatch, useSelector } from "react-redux";
  import NohistoryFound from "../../img/no-history.png";
  import { useEffect } from "react";
  import {
    clearHistory,
    fetchStatusHistory,
  } from "../../store/features/statusHistorySlice";
  import StatusTimelineDialog from "../common/StatusTimelineGrid";

  const statusOptions =["Open", "In Progress", "Escalated", "Resolved", "Closed"];
  const priorityColors = {
    Low: "green",
    Medium: "orange",
    High: "red",
    Critical: "darkred",
  };

  const TicketTable = ({
    tickets,
    formattedDateTime,
    handleOpen,
    handleProgress,
    handleResloved,
    handleEscalate,
    handleCloseTicket,
    handleViewClick,
    handleEdit,
    handleDelete,
  }) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
const [snackbarOpen, setSnackbarOpen] = useState(false);
const [snackbarMessage, setSnackbarMessage] = useState("");
const [snackbarSeverity, setSnackbarSeverity] = useState("warning"); // "success", "error", etc.

    const [openTimelineDialog, setOpenTimelineDialog] = useState(false);
    const [timelineData, setTimelineData] = useState([]);
    const [selectedTicketId, setSelectedTicketId] = useState(null);

    const dispatch = useDispatch();
    const { history, loading } = useSelector((state) => state.statusHistory);

    const handleTimelineOpen = async (ticketId) => {
      console.log(ticketId["_id"]);

      dispatch(clearHistory());
      dispatch(fetchStatusHistory(ticketId["_id"]));
      setSelectedTicketId(ticketId.ticketId);
      setOpenTimelineDialog(true);
    };
const handleSnackbarClose = () => {
  setSnackbarOpen(false);
};

    const handleTimelineClose = async () => {
      setOpenTimelineDialog(false);

      setSelectedTicketId(null);
    };

    const paginatedTickets = tickets.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );

    return (
      <>
        <TableContainer
          component={Paper}
          elevation={0}
          sx={{ backgroundColor: "transparent" }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "bolder" }}>Ticket ID</TableCell>
                <TableCell sx={{ fontWeight: "bolder" }}>
                  Department Ticket ID
                </TableCell>
                <TableCell sx={{ fontWeight: "bolder" }}>Issue Title</TableCell>
                <TableCell sx={{ fontWeight: "bolder" }}>Priority</TableCell>
                <TableCell sx={{ fontWeight: "bolder" }}>
                  Expected Resolution
                </TableCell>
                <TableCell sx={{ fontWeight: "bolder" }}>Status</TableCell>
                <TableCell sx={{ fontWeight: "bolder" }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedTickets && paginatedTickets.length > 0 ? (
                paginatedTickets.map((ticket, index) => {
                  const globalIndex = page * rowsPerPage + index;
                  return (
                    <TableRow key={ticket.ticketId}>
                      <TableCell sx={{ color: "white" }}>
                        {ticket.ticketId}
                      </TableCell>
                      <TableCell sx={{ color: "white" }}>
                        {ticket.depTicketId}
                      </TableCell>
                      <TableCell sx={{ color: "white" }}>
                        {ticket.issueTitle}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: priorityColors[ticket.priority] || "black",
                          fontWeight: "bold",
                        }}
                      >
                        {ticket.priority}
                      </TableCell>
                      <TableCell sx={{ color: "white" }}>
                        {formattedDateTime(ticket.expectedResolutionDate)}
                      </TableCell>
                      <TableCell>
                        <Select
                          value={ticket.status}
                          onChange={(e) => {
                            const newStatus = e.target.value;
                            switch (newStatus) {
                              case "Open":
                                handleOpen(globalIndex);
                                break;
                              case "In Progress":
                                handleProgress(globalIndex);
                                break;
                              case "Resolved":
                                handleResloved(globalIndex);
                                break;
                              case "Escalated":
                                handleEscalate(globalIndex);
                                break;
                              case "Closed":
                                handleCloseTicket(globalIndex);
                                break;
                              default:
                                break;
                            }
                          }}
                          size="small"
                          sx={{
                            minWidth: 120,
                            color: "white",
                            ".MuiOutlinedInput-notchedOutline": {
                              borderColor: "rgba(255,255,255,0.6)",
                            },
                            ".MuiSelect-icon": {
                              color: "white",
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "white",
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              borderColor: "white",
                            },
                          }}
                          variant="outlined"
                        >
                          {statusOptions.map((status) => (
                            <MenuItem key={status} value={status}>
                              {status}
                            </MenuItem>
                          ))}
                        </Select>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: "flex", gap: 1 }}>
                          <Tooltip title="View">
                            <IconButton
                              size="small"
                              color="primary"
                              onClick={() => handleViewClick(globalIndex)}
                            >
                              <VisibilityIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="History">
                            <IconButton
                              size="small"
                              color="info"
                              onClick={() => handleTimelineOpen(ticket)}
                            >
                              <HistoryIcon />
                            </IconButton>
                          </Tooltip>
                          {isAdmin() && (
                            <>
                              <Tooltip title="Edit">
                                <IconButton
                                  size="small"
                                  color="success"
                                  onClick={() => handleEdit(globalIndex)}
                                >
                                  <EditIcon />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Delete">
                                <IconButton
                                  size="small"
                                  color="error"
                                  onClick={() => handleDelete(globalIndex)}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </Tooltip>
                            </>
                          )}
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell sx={{ color: "white" }} colSpan={7} align="center">
                    No Data Found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Box
          className="mui-wrapper mui-isolated-container p-0"
          sx={{
            color: "white",
            px: 2,
            py: 1,
            display: "flex",
            justifyContent: "flex-end",

            borderTop: "1px solid #ccc",
          }}
        >
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={tickets.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(event, newPage) => setPage(newPage)}
            onRowsPerPageChange={(event) => {
              setRowsPerPage(parseInt(event.target.value, 10));
              setPage(0);
            }}
            sx={{
              background: "#8d8787",
              color: "white",
              ".MuiTablePagination-toolbar": {
                color: "white",
              },
                  '.MuiTablePagination-toolbar': { color: 'white',overflow:{
                      xs:"scroll" ,
                      sm:"hidden" 
                    } },
              ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows":
                {
                  color: "white",
                },
            }}
          />
        </Box>
        <StatusTimelineDialog
          openTimelineDialog={openTimelineDialog}
          handleTimelineClose={handleTimelineClose}
          selectedTicketId={selectedTicketId}
          loading={loading}
          history={history}
        />
      </>
    );
  };

  export default TicketTable;
